<template>
  <div class="-mx-8 h-px bg-neutral-200 dark:bg-neutral-500/30" />
</template>
